import { bff_client } from '@/lib/apiClient'
import { apiAgendor } from './api-client'

interface DealAgendor {
  title: string
  dealStatusText?: string
  description?: string
  endTime?: string
  products_entities?: Array<{
    id: number
    unitValue: number
    discount: number
    quantity: number
  }>
  products?: Array<string>
  ranking?: number
  startTime?: string
  ownerUser?: number
  funnel?: number
  dealStage?: number
  value?: number
  allowedUsers?: Array<number>
  allowToAllUsers?: boolean
  customFields?: {}
}

interface CreateDealPeopleAgendorResponse {
  data: {
    id: number
    title: string
    accountId: number
    startTime: any
    endTime: any
    wonAt: any
    lostAt: any
    organization: {
      id: number
      accountId: number
      name: string
      legalName: string
      email: string
      cnpj: string
      description: string
      logo: {
        full: string
        thumb: string
        thumb_large: string
      }
      ranking: number
      website: string
      createdAt: any
      updatedAt: any
      products: Array<{
        id: number
        name: string
        code: string
        categoryId: number
        price: number
        active: boolean
        createdAt: any
      }>
      contact: {
        email: string
        work: string
        mobile: string
        fax: string
        ramal: string
        radio: string
        whatsapp: string
        facebook: string
        twitter: string
        linkedIn: string
        skype: string
        instagram: string
      }
      address: {
        country: string
        district: string
        streetName: string
        streetNumber: number
        additionalInfo: string
        postalCode: string
        state: string
        city: string
      }
      category: {
        id: number
        name: string
      }
      leadOrigin: {
        id: number
        name: string
      }
      sector: {
        id: number
        name: string
      }
      people: Array<{
        id: number
        name: string
        email: string
      }>
      author: {
        accountId: number
        id: number
        name: string
      }
      ownerUser: {
        accountId: number
        id: number
        name: string
      }
      allowedUsers: Array<{
        accountId: number
        id: number
        name: string
      }>
      customFields: {}
      _webUrl: string
    }
    person: {
      id: number
      accountId: number
      name: string
      email: string
      organization: {
        id: string
        name: string
        email: string
      }
      cpf: string
      role: string
      ranking: number
      description: string
      birthday: string
      avatar: string
      createdAt: any
      updatedAt: any
      products: Array<{
        id: number
        name: string
        code: string
        categoryId: number
        price: number
        active: boolean
        createdAt: any
      }>
      contact: {
        email: string
        work: string
        mobile: string
        fax: string
        ramal: string
        radio: string
        whatsapp: string
        facebook: string
        twitter: string
        linkedIn: string
        skype: string
        instagram: string
      }
      address: {
        country: string
        district: string
        streetName: string
        streetNumber: number
        additionalInfo: string
        postalCode: string
        state: string
        city: string
      }
      category: {
        id: number
        name: string
      }
      leadOrigin: {
        id: number
        name: string
      }
      author: {
        accountId: number
        id: number
        name: string
      }
      ownerUser: {
        accountId: number
        id: number
        name: string
      }
      allowedUsers: Array<{
        accountId: number
        id: number
        name: string
      }>
      customFields: {}
      _webUrl: string
    }
    author: {
      accountId: number
      id: number
      name: string
    }
    dealStage: {
      id: number
      name: string
      sequence: number
      funnel: {
        id: number
        name: string
      }
    }
    dealStatus: {
      id: number
      name: string
    }
    lossReason: {
      id: number
      name: string
      description: string
    }
    owner: {
      accountId: number
      id: number
      name: string
    }
    description: string
    createdAt: any
    updatedAt: any
    ranking: number
    value: number
    products_entities: Array<{
      id: number
      createdAt: any
      unitValue: number
      quantity: number
      discount: number
      totalValue: number
    }>
    products: Array<string>
    allowedUsers: Array<{
      accountId: number
      id: number
      name: string
    }>
    _email: string
    customFields: {}
    _webUrl: string
  }
}

interface CreateDealPeopleAgendorRequest {
  personId: number
  dealAgendor: DealAgendor
}

export async function createDealPeopleAgendor({
  personId,
  dealAgendor,
}: CreateDealPeopleAgendorRequest) {
  const response = apiAgendor
    .post(`people/${personId}/deals`, {
      json: dealAgendor,
    })
    .json<CreateDealPeopleAgendorResponse>()

  return response
}

export async function createDealPeople({
  personId,
  dealAgendor,
}: CreateDealPeopleAgendorRequest) {
  const response = bff_client
    .post(`agendor/people/${personId}/deals`, {
      json: dealAgendor,
    })
    .json<CreateDealPeopleAgendorResponse>()

  return response
}
